// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unified-experiment-state-icon__wrapper {
  position: relative;
}
.unified-experiment-state-icon__failed-icon {
  position: absolute;
  top: -2px;
  right: -2px;
}
.v-icon.unified-experiment-state-icon--running {
  color: #ffbf00;
}
.v-icon.unified-experiment-state-icon--idle {
  color: #cccccc;
}
.v-icon.unified-experiment-state-icon--unknown {
  color: #f98890;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/components/experiment-id/experiment-state-icon/UnifiedExperimentStateIcon.less","webpack://./src/neptune-app/components/experiment-id/experiment-state-icon/apply-status-color.less"],"names":[],"mappings":"AAIE;EACE,kBAAA;AAHJ;AAME;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAJJ;ACFE;EACE,cAAA;ADIJ;ACFE;EACE,cAAA;ADIJ;ACFE;EACE,cAAA;ADIJ","sourcesContent":["@import './apply-status-color';\n\n.unified-experiment-state-icon {\n\n  &__wrapper {\n    position: relative;\n  }\n\n  &__failed-icon {\n    position: absolute;\n    top: -2px;\n    right: -2px;\n  }\n}\n\n.v-icon.unified-experiment-state-icon {\n  .apply-status-color();\n}\n","@status-running: #ffbf00;\n@status-idle: #cccccc;\n@red-strawberry: #f98890;\n\n.apply-status-color() {\n  &--running {\n    color: @status-running;\n  }\n  &--idle {\n    color: @status-idle;\n  }\n  &--unknown {\n    color: @red-strawberry;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
